"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const React = __importStar(require("react"));
const Hypervisor_1 = require("./Hypervisor");
class ErrorBoundary extends React.Component {
    state = { hasError: false };
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        if (typeof this.props.onError === 'function') {
            // Loading failed, send this to a bug tracking service
            this.props.onError(error, errorInfo);
        }
        (0, Hypervisor_1.dispatch)('*', 'error', {
            error,
            errorInfo,
            source: { ...this.props },
        });
    }
    render() {
        if (this.state.hasError) {
            if (typeof this.props.errorMessage === 'function') {
                // If errorMessage is in props and it's a proper function, then call it
                return React.createElement(React.Fragment, null, this.props.errorMessage(this.state.error));
            }
            // Let's not render anything so we don't show erroneous UI
            if (process.env.NODE_ENV === 'development') {
                console.error('Error rendering', this.props);
                return React.createElement("h4", null,
                    "Error rendering ",
                    this.props.appName);
            }
            return null;
        }
        return React.createElement(React.Fragment, null, this.props.children);
    }
}
exports.ErrorBoundary = ErrorBoundary;
